export * from './objekt-gespeichert.interface';
